export const validationOptions = {
  validateOnBlur: true,
  validateOnModelUpdate: false,
};

export enum ActivityWhatDidYouLikeOptions {
  IncreasedKnowledge = 'increased_knowledge',
  ImproveCommunicationWithHealthcareTeam = 'improve_communication_with_healthcare_team',
  InformationToReviewLater = 'information_to_review_later',
  ApplyInformationOnPractice = 'apply_information_on_practice',
  FacilitatedValuesOrEthicsToInterprofessionalPractice = 'facilitated_values_or_ethics_to_interprofessional_practice',
}

export enum CommitmentToChangeOptions {
  RegularlyAssessCOVID19Outpatients = 'regularly_assess_covid_19_outpatients',
  UseDrugInteractionCheckers = 'use_drug_interaction_checkers',
  ApplyEvidenceBasedGuidelines = 'apply_evidence_based_guidelines',
  EngageWithPharmacistsNursesAndInfectiousDiseaseSpecialists = 'engage_with_pharmacists_nurses_and_infectious_disease_specialists',
  UseReferenceTools = 'use_reference_tools',
  NoPlanToMakeChanges = 'no_plan_to_make_changes',
  Other = 'other',
}

export enum TeacherRatingsOptions {
  TeachingStrategies = 'teachingStrategies',
  Expertise = 'expertise',
  Engaging = 'engaging',
  ContentSelection = 'contentSelection',
}

export enum ActivityCredibilityRatingsOptions {
  ChangePracticeBasedOnActivity = 'changePracticeBasedOnActivity',
  ClinicallyRelevant = 'clinicallyRelevant',
  BalancedAndObjective = 'balancedAndObjective',
  FreeOfCommercialBias = 'freeOfCommercialBias',
  PercentageOfNewInformation = 'percentageOfNewInformation',
}
